import { render } from "./PageListarSecretaria.vue?vue&type=template&id=bf96e318"
import script from "./PageListarSecretaria.vue?vue&type=script&lang=js"
export * from "./PageListarSecretaria.vue?vue&type=script&lang=js"

import "./PageListarSecretaria.vue?vue&type=style&index=0&id=bf96e318&lang=css"
/* custom blocks */
import block0 from "./PageListarSecretaria.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__